/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');

if (window.Vue === undefined) {
    window.Vue = require('vue').default;

    window.Bus = new Vue();
}

Vue.config.devtools = true

/**
 * Next, we will create a fresh Vue application instance. You may then begin
 * registering components with the application instance so they are ready
 * to use in your application's views. An example is included for you.
 */

//// directive for Tooltips
Vue.directive('tooltip', {
  bind(el, binding, vnode){
    $(el).tooltip({
             title: binding.value,
             placement: binding.arg,
             trigger: 'hover'
         })
  },
  componentUpdated(el, binding, vnode, oldVnode) {
    $(el).tooltip('dispose');
    $(el).tooltip({
             title: binding.value,
             placement: binding.arg,
             trigger: 'hover'
         })
  },
  unbind(el, binding) {
    $(el).tooltip('dispose');
  }
});

Vue.filter('commanumeric', function (value) {
    value = (value == undefined) ? "" : value;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('sizeDisplay', function (value) {
    value = (value == undefined) ? "" : value;
    return value.substr(0,1)+"'-"+value.substr(1)+'"';
    // return value / 12;
    // return (parseInt(value/12) + "'-" + Math.round(value%12,1)+'"');
});

Vue.filter('currency', function (value) {
  if (value != null) {
    return '$' + parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
});

Vue.component(
    'example-component',
    require('./components/ExampleComponent.vue').default
);

Vue.component(
    'products',
    require('./components/Products.vue').default
);

Vue.component(
    'order-form',
    require('./components/OrderForm.vue').default
);

Vue.component(
    'view-order-form',
    require('./components/ViewOrderForm.vue').default
);

Vue.component(
    'view-order-modal',
    require('./components/modals/ViewOrderModal.vue').default
);

Vue.component(
    'orders',
    require('./components/Orders.vue').default
);

Vue.component(
    'customers',
    require('./components/Customers.vue').default
);

Vue.component(
    'edit-order-items-modal',
    require('./components/modals/EditOrderItemsModal.vue').default
);

Vue.component(
    'edit-shipstation-order-modal',
    require('./components/modals/EditShipstationOrderModal.vue').default
);

Vue.component(
    'edit-customer-modal',
    require('./components/modals/EditCustomerModal.vue').default
);

Vue.component(
    'send-quote-modal',
    require('./components/modals/SendQuoteModal.vue').default
);

// import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
// Vue.use(VueSweetalert2);
import swal from 'sweetalert2';
window.Swal = swal;

import Vue from 'vue';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

// import ExampleComponent from './components/ExampleComponent.vue';
// app.component('example-component', ExampleComponent);

// import OrderForm from './components/OrderForm.vue';
// app.component('order-form', OrderForm);

// import Products from './components/Products.vue';
// app.component('products', Products);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Object.entries(import.meta.globEager('./**/*.vue')).forEach(([path, definition]) => {
//     app.component(path.split('/').pop().replace(/\.\w+$/, ''), definition.default);
// });

/**
 * Finally, we will attach the application instance to a HTML element with
 * an "id" attribute of "app". This element is included with the "auth"
 * scaffolding. Otherwise, you will need to add an element yourself.
 */

const app = new Vue({
    el: '#app',
});

